import PropTypes from 'prop-types';
import React from 'react';
import isNil from 'lodash/isNil';

const ConfirmationScreenSection = ({ title, oldValue, newValue }) => {
  let text = (
    <p>
      Changed from <span className="u-type--bold u-font-color-grey">{ oldValue }</span>{ ' ' }
      to <span className="u-type--bold u-font-color-primary">{ newValue }</span>.
    </p>
  );
  if (isNil(oldValue)) {
    text = <p>Added value <span className="u-type--bold u-font-color-primary">{ newValue }</span>.</p>;
  }
  if (!newValue) {
    text = <p>Deleted value <span className="u-type--bold u-font-color-grey">{ oldValue }</span>.</p>;
  }
  return (
    <div className="layout__item u-pr">
      <div className="c-label c-label--light">{ title }</div>
      { text }
    </div>
  );
};

ConfirmationScreenSection.propTypes = {
  title: PropTypes.string.isRequired,
  oldValue: PropTypes.string.isRequired,
  newValue: PropTypes.string.isRequired,
};

export default ConfirmationScreenSection;
